import { NotificationData } from ".";

const notificationDatas: NotificationData[] = [
  {
    code: "KFE-000", // DO NOT USE!
    developerMessage: "Unkown error.",
    type: "error",
  },
  {
    code: "KFE-001",
    developerMessage: "Draft could not be saved.",
    type: "error",
  },
  {
    code: "KFE-002",
    developerMessage: "Draft could not be saved, photos are still uploading.",
    type: "error",
  },
  {
    code: "KFE-003",
    developerMessage: "Max pages reached",
    type: "error",
  },
];

export default notificationDatas;
